const drawFreeform = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M5.47 2.53a.664.664 0 0 0-.94.94l6 6a2.164 2.164 0 1 1-3.06 3.06l-4-4a.664.664 0 0 0-.94.94l2 2a2.164 2.164 0 0 1-3.06 3.06l-1-1 1.06-1.06 1 1a.664.664 0 1 0 .94-.94l-2-2a2.164 2.164 0 0 1 3.06-3.06l4 4a.664.664 0 1 0 .94-.94l-6-6a2.164 2.164 0 1 1 3.06-3.06l9 9-1.06 1.06z" clip-rule="evenodd"/></svg>',
};

export { drawFreeform as default };
